import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Tipologia } from 'app/modules/models/tipologia.model';
import { UsuariosService } from '../usuarios.service';
import { UsuarioModel } from '../models/usuario-form.model';
import { environment } from 'enviroments/environment';

@Component({
    selector: 'app-agregar-usuario',
    templateUrl: 'agregar-usuario.component.html',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatButtonModule,
    ],
})
export class AgregarUsuarioComponent implements OnInit {
    form: UsuarioModel= new UsuarioModel();
    originalForm: UsuarioModel | null = null;

    roles: Tipologia[] = [];
    dependencias: Tipologia[] = [];

    isEdit = false;
    showPassword = false;

    constructor(
        private usuariosService: UsuariosService,
        public router?: Router,
        public dialogRef?: MatDialogRef<AgregarUsuarioComponent>,
        @Inject(MAT_DIALOG_DATA) public data?: UsuarioModel,
    ) {
        this.getRoles();
        this.getDependencia()

        if (this.data) {
            this.isEdit = true;
            this.form.usuarioId = this.data.usuarioId
            this.form.nombreCompleto = this.data.nombreCompleto
            this.form.email = this.data.email
            this.form.password = '';
        }
    }

    ngOnInit(): void {}

    private getRoles(): void {
        this.usuariosService.getTipologias(environment.TIPOLOGIA_ID_ROLES)
        .then((response:Tipologia[])=>{
            this.roles = response[0].tipologias;

            if (this.isEdit && this.data?.rol) {
                this.form.rol =
                    this.roles.find(
                        r => r.tipologiaId === this.data!.rol!.tipologiaId
                    ) ?? null;
            } else if (!this.isEdit && this.roles.length) {
                // Precargar rol solo en registro de nuevo usuario
                this.form.rol = this.roles[0];
            }
        })
    }

    private getDependencia(): void {
        this.usuariosService.getTipologias(environment.TIPOLOGIA_ID_DEPENDENCIA)
        .then((response:Tipologia[])=>{
            this.dependencias = response[0].tipologias;

            if (this.isEdit && this.data?.dependencia) {
                this.form.dependencia =
                    this.dependencias.find(
                        d => d.tipologiaId === this.data!.dependencia!.tipologiaId
                    ) ?? this.form.dependencia;
            } else if (!this.isEdit && this.dependencias.length) {
                // Precargar dependencia solo en registro de nuevo usuario
                this.form.dependencia = this.dependencias[0];
            }
        })
    }

    async submit(_ngForm: any) {
        try {
            // al editar solo se envian campos que cambiaron
            if (this.isEdit && this.form.usuarioId != null) {
            const params: any= {};
            const orig = this.data as UsuarioModel;

            if (orig.nombreCompleto !== this.form.nombreCompleto) {
                params.nombreCompleto = this.form.nombreCompleto;
            }

            if (orig.email !== this.form.email) {
                params.Email = this.form.email;
            }

            if (orig.rol?.tipologiaId !== this.form.rol?.tipologiaId) {
                params.Rol = this.form.rol?.tipologiaId ?? this.form.rol;
            }

            if (orig.dependencia?.tipologiaId !== this.form.dependencia?.tipologiaId) {
                params.Dependencia = this.form.dependencia?.tipologiaId ?? this.form.dependencia;
            }

            if (this.form.password && this.form.password.trim() !== '') {
                params.Password = this.form.password.trim();
            }

            if (Object.keys(params).length === 0) {
                this.dialogRef?.close(false);
                return;
            }

            // Actualizar usuario
            await this.usuariosService.actualizarUsuario(this.form.usuarioId, params);
                this.dialogRef?.close(true);
                return;
            }

            // Crear usuario
            await this.usuariosService.crearUsuario(this.form);
            this.dialogRef?.close(true);

        } catch (error) {
            console.error('Error:', error);
        }
    }




}
